// extracted by mini-css-extract-plugin
module.exports = {"container":"bookmarks-list_container__2OA0Z"};